import {
  DEFAULT_SOURCING_FEE_MINIMUM,
  DEFAULT_SOURCING_FEE_PERCENTAGE,
  UK_VAT_RATE,
} from '../constants/sourcingFee'
import type { ThemeProps } from './theme'

type SourcingFeeSettings = Pick<ThemeProps, 'sourcingFeePercentage' | 'sourcingFeeMinimum' | 'sourcingFeeVatIncluded'>

const PERCENTAGE_DECIMALS = 2
const percentageFormat = new Intl.NumberFormat('en-GB', { maximumFractionDigits: PERCENTAGE_DECIMALS })

function formatPounds(amount: number): string {
  const rounded = Math.round(amount * 100) / 100
  const wholePounds = Number.isInteger(rounded)
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: wholePounds ? 0 : 2,
    maximumFractionDigits: wholePounds ? 0 : 2,
  }).format(rounded)
}

// The T&Cs quote the fee "plus VAT"; sites store it including VAT unless they say otherwise.
export function sourcingFeeExcludingVat(settings: SourcingFeeSettings | null | undefined) {
  const percentage = settings?.sourcingFeePercentage || DEFAULT_SOURCING_FEE_PERCENTAGE
  const minimum = settings?.sourcingFeeMinimum || DEFAULT_SOURCING_FEE_MINIMUM
  const vatDivisor = settings?.sourcingFeeVatIncluded === false ? 1 : 1 + UK_VAT_RATE
  return {
    percentage: percentageFormat.format(percentage / vatDivisor),
    minimum: formatPounds(minimum / vatDivisor),
  }
}
